import { render } from "./ValidationExplanation.vue?vue&type=template&id=6bb0b85d&scoped=true"
import script from "./ValidationExplanation.vue?vue&type=script&lang=js"
export * from "./ValidationExplanation.vue?vue&type=script&lang=js"

import "./ValidationExplanation.vue?vue&type=style&index=0&id=6bb0b85d&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb0b85d"]])

export default __exports__